import { isFeatureEnabled } from 'owa-feature-flags';

const UPSELL_URL_TREATMENT2_SETTING = 'https://go.microsoft.com/fwlink/?linkid=2124992';
const UPSELL_URL_SKITTLE_BASIC_SETTING = ' https://go.microsoft.com/fwlink/?linkid=2145121';
const UPSELL_URL_PREMIUM_PREVIEW_BASED_ON_DATE = 'https://go.microsoft.com/fwlink/?linkid=2146730';
const UPSELL_URL_PREMIUM_PREVIEW_BASED_ON_COUNT = 'https://go.microsoft.com/fwlink/?linkid=2146731';

export function openUpsellUrlFromSettingsDialog(): void {
    let goPremiumLink: string;

    if (isFeatureEnabled('mc-officeEditorUpsellSkittle')) {
        goPremiumLink = UPSELL_URL_SKITTLE_BASIC_SETTING;
    } else if (isFeatureEnabled('mc-officeEditorUpsellSkittleBasedOnDate')) {
        goPremiumLink = UPSELL_URL_PREMIUM_PREVIEW_BASED_ON_DATE;
    } else if (isFeatureEnabled('mc-officeEditorUpsellSkittleBasedOnCount')) {
        goPremiumLink = UPSELL_URL_PREMIUM_PREVIEW_BASED_ON_COUNT;
    } else {
        goPremiumLink = UPSELL_URL_TREATMENT2_SETTING;
    }
    window.open(goPremiumLink, '_blank');
}
